import { Fragment } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { useAppDispatch } from "../../store/hooks";
import { EventsActions } from "../../store/events-slice";
import { UIActions } from "../../store/ui-slice";
import { leaveEventForm } from "../../store/events-actions";
import EventsReminder from "../Events/EventsReminder";
import { getLongDate } from "../helpers/DateHelper";

import classes from "./Header.module.css";
import { t } from "../../i18n";

const Header = () => {
  const { deviceCalendar, addEvent, canSaveForm } = useSelector(
    (state: RootState) => state.ui
  );
  const { reminderEvents, userSelectedDate, eventToEdit } = useSelector(
    (state: RootState) => state.events
  );

  const fixedClass = `${classes.fixed} ${
    window.desktop ? classes.fixedDesktop : ""
  }`;

  const mobileClass = `${classes.mobile} ${
    addEvent || eventToEdit !== null ? classes.hidden : ""
  } ${window.desktop ? classes.mobileDesktop : ""}`;

  const outputSelectedDate = getLongDate(userSelectedDate);

  const dispatch = useAppDispatch();

  const showDeviceCalendarHandler = () => {
    dispatch(UIActions.showDeviceCalendar());
  };

  const backHandler = () => {
    if (deviceCalendar) {
      dispatch(UIActions.hideDeviceCalendar());
    } else if (addEvent) {
      dispatch(leaveEventForm(UIActions.hideEventForm()));
    } else if (eventToEdit !== null) {
      dispatch(leaveEventForm(EventsActions.unsetEditEvent()));
    }
  };

  const onAddHandler = () => {
    dispatch(UIActions.showAddForm());
  };

  return (
    <Fragment>
      <div className={fixedClass}></div>
      <div className={mobileClass}>
        {(window.desktop ||
          (!deviceCalendar &&
            !addEvent &&
            eventToEdit === null)) && (
          <div>
            <div className={classes["add-button-wrapper"]}>
              <button className={classes["add-button"]} onClick={onAddHandler}>
                <span className={classes["add-button-icon"]}>
                  <svg className="svg" viewBox="0 0 26 26">
                    <circle
                      className={classes["add-button-icon-path"]}
                      cx="13"
                      cy="13"
                      r="12"
                    />
                    <line
                      className={classes["add-button-icon-plus"]}
                      x1="7"
                      y1="13"
                      x2="19"
                      y2="13"
                    />
                    <line
                      className={classes["add-button-icon-plus"]}
                      x1="13"
                      y1="7"
                      x2="13"
                      y2="19"
                    />
                  </svg>
                </span>
                <span className={classes["add-button-label"]}>
                  {t.addNewEvent}
                </span>
              </button>
            </div>

            {reminderEvents.length !== 0 && <EventsReminder />}

            <div className={classes["calendar-button-wrapper"]}>
              <button
                onClick={showDeviceCalendarHandler}
                className={classes["calendar-button"]}
              >
                <span className={classes["calendar-icon"]}>
                  <svg className="svg" viewBox="0 0 44 43.91">
                    <path
                      className={classes["calendar-icon-path"]}
                      fillRule="evenodd"
                      d="M6938.5,9602.86a1.535,1.535,0,1,0-1.5-1.54A1.52,1.52,0,0,0,6938.5,9602.86Zm14,0a1.535,1.535,0,1,0-1.5-1.54A1.52,1.52,0,0,0,6952.5,9602.86Zm0,11.23a3.576,3.576,0,1,0-3.5-3.57A3.539,3.539,0,0,0,6952.5,9614.09Zm-21,7.15a1.53,1.53,0,1,0-1.5-1.53A1.517,1.517,0,0,0,6931.5,9621.24Zm14,0a1.53,1.53,0,1,0-1.5-1.53A1.517,1.517,0,0,0,6945.5,9621.24Zm-7,0a1.53,1.53,0,1,0-1.5-1.53A1.517,1.517,0,0,0,6938.5,9621.24Zm14,0a1.53,1.53,0,1,0-1.5-1.53A1.517,1.517,0,0,0,6952.5,9621.24Zm7-9.19a1.535,1.535,0,1,0-1.5-1.53A1.517,1.517,0,0,0,6959.5,9612.05Zm-28,0a1.535,1.535,0,1,0-1.5-1.53A1.517,1.517,0,0,0,6931.5,9612.05Zm7,0a1.535,1.535,0,1,0-1.5-1.53A1.517,1.517,0,0,0,6938.5,9612.05Zm7,0a1.535,1.535,0,1,0-1.5-1.53A1.517,1.517,0,0,0,6945.5,9612.05Zm0-9.19a1.535,1.535,0,1,0-1.5-1.54A1.52,1.52,0,0,0,6945.5,9602.86Zm14,0a1.535,1.535,0,1,0-1.5-1.54A1.52,1.52,0,0,0,6959.5,9602.86Zm-34.5-6.15a2.013,2.013,0,0,1,1.98-2.02h36.04a2.006,2.006,0,0,1,1.98,2.02v27.61a2.022,2.022,0,0,1-1.98,2.03h-36.04a2.015,2.015,0,0,1-1.98-2.03v-27.61Zm-2-8.14a4.037,4.037,0,0,1,3.98-4.1h36.04a4.037,4.037,0,0,1,3.98,4.1v35.73a4.034,4.034,0,0,1-3.98,4.09h-36.04a4.034,4.034,0,0,1-3.98-4.09v-35.73Z"
                      transform="translate(-6923 -9584.47)"
                    />
                  </svg>
                </span>
              </button>
            </div>
          </div>
        )}
        {!window.desktop &&
          (deviceCalendar ||
            addEvent ||
            eventToEdit !== null) && (
            <div className={classes.action}>
              <button onClick={backHandler} className={classes.back}>
                <span className={classes.backIcon}>
                  <svg className="svg" viewBox="0 0 26 42">
                    <path
                      d="M6854.88,9999l-21.88,21,21.88,21,4.12-4-17.75-17,17.75-17Z"
                      transform="translate(-6833 -9999)"
                    />
                  </svg>
                </span>
                <span className="backLabel">{outputSelectedDate}</span>
              </button>
              {(addEvent || eventToEdit !== null) && (
                <button
                  type="submit"
                  className={classes.save}
                  form="event-form"
                  disabled={!canSaveForm}
                >
                  {t.save}
                </button>
              )}
            </div>
          )}
      </div>
    </Fragment>
  );
};

export default Header;
